// test1785
(1785 && 0);
